import React, { createContext, useEffect, useReducer } from 'react';

import UserReducer, { InitialtUser, UserActions } from './userReducer';

import { getToken, getCurrentUser, wsLogin, wsLogout } from 'services/WService';
import { wsInit } from 'services/WService';

const UserContext = createContext({
  ...InitialtUser,
  method: 'JWT',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  setUser: () => {},
});

const UserProvider = (props) => {
  const { children } = props;
  const [userState, userDispacher] = useReducer(UserReducer, InitialtUser);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = await getToken();
        wsInit();
        if (accessToken) {
          const user = await getCurrentUser();
          userDispacher({
            type: UserActions.INITIALIZE,
            payload: {
              isAuthenticated: true,
              user: user.data,
            },
          });
        } else {
          userDispacher({
            type: UserActions.INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
              permissions: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        userDispacher({
          type: UserActions.INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (username, password, captcha, authKey) => {
    const userdata = await wsLogin({ username, password, captcha, authKey });

    if (!!userdata['2fa_error']) {
      return userdata;
    }

    userDispacher({
      type: UserActions.LOGIN,
      payload: {
        user: userdata.data,
      },
    });
  };

  const setUser = (user) => {
    userDispacher({
      type: UserActions.INITIALIZE,
      payload: {
        isAuthenticated: true,
        user: user,
      },
    });
  };

  const logout = async () => {
    await wsLogout();
    userDispacher({ type: UserActions.LOGOUT });
  };

  const hasPermission = (permission) => {
    // console.log(userState);
    return userState.permissions?.includes(permission);
  };

  const allPermissions = () => {
    return userState.permissions;
  };
  const isAuthenticated = () => {
    return userState.isAuthenticated;
  };
  const isInitialized = () => {
    return userState.isInitialized;
  };

  return (
    <UserContext.Provider
      value={{
        ...userState,
        method: 'JWT',
        login,
        logout,
        hasPermission,
        isAuthenticated,
        isInitialized,
        allPermissions,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

const WithUser = (Child) => (props) => (
  <UserContext.Consumer>
    {(context, i) => <Child key={i} {...props} userContext={context} />}
  </UserContext.Consumer>
);

export { UserProvider, WithUser, UserContext };
